export default __webpack_public_path__ + "static/media/woman-header1.4d4136ea.png";